import { css as _css } from "@emotion/core";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from "react";
import PropTypes from "prop-types";
import useTheme from "../hooks/useTheme";
import { jsx as ___EmotionJSX } from "@emotion/core";

function LinkedIn(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      hoverColor = _ref.hoverColor,
      testId = _ref.testId;
  var theme = useTheme();
  return ___EmotionJSX("svg", {
    css: /*#__PURE__*/_css({
      display: "block",
      fill: primaryColor,
      transition: hoverColor ? theme.transitions.icon : null,
      ":hover": _objectSpread({}, hoverColor && {
        fill: hoverColor
      })
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M21.6610422,10.8859127 C24.7727047,10.8859127 27,12.7847222 27,16.7132937 L27,26 L22.4799007,26 L22.4799007,18.3013784 C22.4799007,16.1894841 21.677132,15.0109127 20.0066606,15.0109127 C18.1890819,15.0109127 17.239206,16.2388784 17.239206,18.3013784 L17.239206,26 L12.8828784,26 L12.8828784,11.3333333 L17.239206,11.3333333 L17.239206,13.3085317 C17.239206,13.3085317 18.5493797,10.8859127 21.6610422,10.8859127 Z M9.97866005,11.3333333 L9.97866005,26 L5.43672457,26 L5.43672457,11.3333333 L9.97866005,11.3333333 Z M7.68585608,4 C9.16957033,4 10.3717122,5.21188388 10.3717122,6.70634921 C10.3717122,8.20081454 9.16957033,9.41269841 7.68585608,9.41269841 C6.20271647,9.41269841 5,8.20081454 5,6.70634921 C5,5.21188388 6.20271647,4 7.68585608,4 Z",
    fillRule: "evenodd"
  }));
}

LinkedIn.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  hoverColor: PropTypes.string,
  testId: PropTypes.string
};
export default LinkedIn;